import React, {Component} from 'react';
import AppNavbar from './blocks/AppNavbar';
import AppSideNav from './blocks/AppSideNav';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import Home from './containers/Home';
import BlueprintList from './containers/BlueprintList';
import BlueprintSubmit from './containers/BlueprintSubmit';
import BlueprintReview from './containers/BlueprintReview';
import DiscussionList from './containers/DiscussionList';
import DiscussionView from './containers/DiscussionView';
import DiscussionEdit from './containers/DiscussionEdit';
import FaqList from './containers/FaqList';
import ProfileEdit from './containers/ProfileEdit';
import ManageUsers from './containers/ManageUsers';
import ManageGroups from './containers/ManageGroups';
import * as helpers from './lib/helpers'
import ManageFaqs from './containers/ManageFaqs';

class App extends Component {

  constructor(props) {
    super(props);
    this.createBlueprintList = this.createBlueprintList.bind(this);
  }

  createBlueprintList(mode = 'submit') {
    return function() {
      return (
          <BlueprintList
              mode={mode}
              key={mode}
          />
      );
    };
  }

  render() {
    return (
        <div>
          <AppNavbar/>
          <div className="mid-section">
            <div className="container">
              <div className="row">
                <div className="col-md-2" style={{
                  flex: '0 0 20%',
                  maxWidth: '20%',
                }}>
                  <AppSideNav/>
                </div>
                <div className="col-md-9"
                     style={{
                       flex: '0 0 80%',
                       maxWidth: '80%',
                     }}
                >
                  <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/discussions"
                           component={DiscussionList}/>
                    <Route exect path="/discussions/create"
                           component={DiscussionEdit}/>
                    <Route exact path="/discussions/:discussionId"
                           component={DiscussionView}/>
                    <Route exect path="/discussions/:discussionId/edit"
                           component={DiscussionEdit}/>
                    <Route
                        path="/blueprints/submit/:groupId/:blueprintId/:page?"
                        component={BlueprintSubmit}/>
                    <Route
                        path="/blueprints/review/:groupId/:blueprintId/:page?"
                        component={BlueprintReview}/>
                    <Route exact path="/blueprints/submit"
                           render={this.createBlueprintList()}/>
                    <Route exact path="/blueprints/review"
                           render={this.createBlueprintList('review')}/>
                    <Route path="/faq" component={FaqList}/>
                    <Route exact path="/profile/edit" component={ProfileEdit}/>
                    <Route exact path="/admin/users" component={ManageUsers}/>
                    <Route exact path="/admin/groups" component={ManageGroups}/>
                    <Route exact path="/admin/faq" component={ManageFaqs}/>
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js